import { Tooltip, withStyles } from "@material-ui/core";

const LightTooltip = withStyles({
  tooltip: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    fontSize: 12,
  },
})(Tooltip);

export default LightTooltip;